module.exports = __webpack_public_path__ + "static/media/buy-online.90b00c74.jpeg";